import React, {useContext, useEffect, useState} from 'react';
import {Input} from 'semantic-ui-react';
// import { mdiFood } from '@mdi/js';

export const Expense = ({id, name, icon, stripeCategories, selected, onSelect, approved, onApprove, onRemove, currentExpenseProgram}) => {

    const [inputValue, setInputValue] = useState(0)
    console.info({icon})

    /*useEffect(() => {
      console.info({perkComponent: props});
      // eslint-disable-next-line
    }, []);*/
    // console.info({approved});

    /*let actionButtonClass, actionButtonLabel = '';
    switch (status) {
        case 'pending-deactivation':
            actionButtonClass = '';
            actionButtonLabel = 'Re-activate';
            break;
        case 'inactive':
            actionButtonClass = 'primary';
            actionButtonLabel = 'Approve';
            break;
        default: // active
            actionButtonClass = 'secondary';
            actionButtonLabel = 'Remove';
            break;
    }*/

    const handleApproveRemove = (approvedExpense) => {
        if (approvedExpense) {
            onRemove(id, name);
        } else {
            onApprove(id, Number(inputValue), name)
        }
    }

    /*const actionButton =
        (<Fragment>
            <div className={`ui button ${actionButtonClass}`}>{actionButtonLabel}</div>
            {status === 'pending-deactivation' &&
            (<h6>Will be removed by 20-12-2020</h6>)}
        </Fragment>);*/

    return (
        <tr className="perk-item" style={{backgroundColor: 'rgba(238, 241, 243, 1)'}}>
            {/* <td className="perk-provider"><i className="material-icons md-36">{icon.name}</i><span>{name}</span> */}
            <td style={{paddingTop: 16}} >{icon.package === 'MaterialIcons' ? 
                                                // <i className="material-icons md-36">{icon.name}</i>
                                                <span class="material-icons" style={{fontSize: 36}}>{icon.name}</span>
                                            :
                                                icon.package === 'MaterialCommunityIcons' ?
                                                    <span style={{fontSize: 36, alignSelf: 'center'}} className={`mdi mdi-${icon.name}`} />
                                                :
                                                    icon.package === 'Ionicons' ?
                                                        <ion-icon name={icon.name} style={{fontSize: 36}}></ion-icon>
                                                    :
                                                        <i className={`fas fa-${icon.name}`} style={{fontSize: 30}}></i>
                                            }</td>
            <td className="perk-provider"><span style={{marginLeft: 0}}>{name}</span>
            </td>
            <td>{
                    approved ? 
                        '$' + String(currentExpenseProgram.expenseCategories.filter(expense => {return expense.expenseCategoryId === id})[0].spendingControl) + ' /Approved Employee'
                    :
                        <Input
                            label={{ basic: true, content: '/Approved Employee' }}
                            type={'number'}
                            labelPosition='right'
                            placeholder='Enter Spending Limit'
                            onChange = {(event, data) => {setInputValue(data.value)}} 
                        />
                }
            </td>
            <td className="right aligned">
                {approved ? 
                    <button className="ui button" style={{color: '#FCC65C', backgroundColor: '#999999', width: 102.5}} onClick={e => handleApproveRemove(approved)}>Remove</button>
                :
                    <button disabled={!inputValue} className="ui button" style={{color: 'rgba(0, 200, 136, 1)', backgroundColor: '#999999', width: 102.5}} onClick={e => handleApproveRemove(approved)}>Approve</button>
                }
            </td>
        </tr>
    );
};